import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, googleLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success('Welcome back!');
      navigate(from, { replace: true });
    } catch {
      toast.error('Invalid credentials');
    }
    setLoading(false);
  };

  const handleGoogle = async (credentialResponse) => {
    try {
      await googleLogin(credentialResponse.credential);
      toast.success('Welcome!');
      navigate(from, { replace: true });
    } catch {
      toast.error('Google login failed');
    }
  };

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <form onSubmit={handleSubmit} style={{ width: 360, padding: 40, border: '1px solid #eee' }}>
        <h2 style={{ fontSize: 22, fontWeight: 300, letterSpacing: 1, textAlign: 'center', marginBottom: 32 }}>Login</h2>
        <input value={username} onChange={e => setUsername(e.target.value)} placeholder="Username" required
          style={{ width: '100%', padding: '12px', border: '1px solid #ddd', marginBottom: 12 }} />
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Password" required
          style={{ width: '100%', padding: '12px', border: '1px solid #ddd', marginBottom: 20 }} />
        <button type="submit" disabled={loading}
          style={{ width: '100%', padding: '12px', background: '#1a1a1a', color: '#fff', border: 'none', letterSpacing: 2, textTransform: 'uppercase', fontSize: 13, cursor: 'pointer', opacity: loading ? 0.6 : 1 }}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
        <div style={{ display: 'flex', alignItems: 'center', margin: '20px 0' }}>
          <div style={{ flex: 1, height: 1, background: '#ddd' }} />
          <span style={{ padding: '0 12px', fontSize: 12, color: '#999' }}>OR</span>
          <div style={{ flex: 1, height: 1, background: '#ddd' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <GoogleLogin onSuccess={handleGoogle} onError={() => toast.error('Google login failed')} />
        </div>
        <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#666' }}>
          Don't have an account? <Link to="/register" style={{ color: '#1a1a1a' }}>Register</Link>
        </p>
      </form>
    </div>
  );
}
